/**
 * Parse user decimal input that may use `.` or `,` as separator.
 * Returns null for empty / invalid / non-positive values when requirePositive is true.
 */
export function parseDecimalInput(value, { requirePositive = true } = {}) {
    if (value == null) return null;
    const raw = String(value).trim();
    if (!raw) return null;

    const normalized = raw.replace(",", ".");
    if (!/^-?\d+(\.\d+)?$/.test(normalized)) return null;

    const num = Number(normalized);
    if (!Number.isFinite(num)) return null;
    if (requirePositive && num <= 0) return null;
    return num;
}

/**
 * Trip fuel cost: (km / 100) × (L/100km) × price per liter.
 */
export function computeFuelCost({
    distanceKm,
    consumptionLPer100Km,
    pricePerLiter,
}) {
    const km = parseDecimalInput(distanceKm);
    const consumption = parseDecimalInput(consumptionLPer100Km);
    const price = parseDecimalInput(pricePerLiter);
    if (km == null || consumption == null || price == null) return null;

    return (km / 100) * consumption * price;
}

export function formatFuelCost(value) {
    if (!Number.isFinite(value)) return "";
    const rounded = Math.round(value * 100) / 100;
    return Number.isInteger(rounded)
        ? String(rounded)
        : rounded.toFixed(2).replace(/\.?0+$/, "");
}

export function formatFuelCostLabel({
    distanceKm,
    consumptionLPer100Km,
    pricePerLiter,
}) {
    const cost = computeFuelCost({
        distanceKm,
        consumptionLPer100Km,
        pricePerLiter,
    });
    if (cost == null) return "";
    return formatFuelCost(cost);
}
